export {
  default,
  getServerSideProps,
} from '@/views/B2BLanding/pages/FreeTrial';
